import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { canAccessNav } from 'permissions';
import LandingPage from 'app/public/LandingPage';

export function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading-screen">Chargement...</div>;
  if (!user) {
    if (location.pathname === '/') return <LandingPage />;
    return <Navigate to="/login" />;
  }
  if (user.doit_changer_mot_de_passe) return <Navigate to="/force-change-password" />;
  return children;
}

export function RoleRoute({ path, children }) {
  const { user } = useAuth();
  const roles = user?.roles || (user?.role ? [user.role] : []);
  if (!canAccessNav(roles, path)) {
    return <Navigate to="/" />;
  }
  return children;
}

export default function PermissionGuard({ path, children }) {
  return <RoleRoute path={path}>{children}</RoleRoute>;
}
